import { IonRow } from '@ionic/react'
import { getDirMode } from 'mobile_web/modules/platform'
import React from 'react'

interface Props {
	title: string
	noOverflow?: boolean
}

const SectionHeader: React.FC<Props> = ({ title, noOverflow }): React.ReactElement => (
	<IonRow className="block-header" dir={getDirMode()}>
		<h2 className={`subheading ${noOverflow ? 'subheading-no-overflow' : ''}`} data-cy="story-screen-section-heading">
			{title}
		</h2>
	</IonRow>
)

export default SectionHeader
